import { mapActions } from 'vuex';
import { formMixin } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';
import documentUploadMixin from '@/mixins/documentUpload';

export default {
  mixins: [
    documentUploadMixin,
    loaderMixin,
    formMixin,
  ],
  props: {
    depositPayload: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        agreed: false,
      },
    };
  },
  computed: {
    amountDisplay() {
      return Number(this.depositPayload.amount).toFixed(2);
    },
    isConfirmDisabled() {
      return !this.isFormEnabled || !this.fields.agreed;
    },
  },
  methods: {
    ...mapActions('wallet', ['submitDepositUSDCoin']),
    onSubmit() {
      this.formDisable();
      this.loaderAdd(document.body);
      this.submitDepositUSDCoin(this.depositPayload)
        .then((data) => {
          this.loaderRemove(document.body);
          if (this.checkDocumentUploadFlags(data)) return;
          this.formEnable();
          window.location.href = data.url;
        })
        .catch((error) => {
          this.loaderRemove(document.body);
          if (this.checkDocumentUploadFlags(error.response.data)) return;
          this.formEnable();
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/coinbase-process-overview/coinbase-process-overview.js